<template>

	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-8 col-md-10 col-sm-12 mx-auto user-panel mt-5 mb-5 text-center">
				
				<div class="alert alert-danger pt-3 pb-3 mx-auto mt-5" style="max-width: 600px;">
					Coming soon.
				</div>

			</div>
		</div>
	</div>
			
</template>

<script>

	export default {
		name: 'Knowledge Base',
		data () {
			return {
				msg: 'Welcome to Your Vue.js App'
			}
		}
	}
</script>

<style scoped>

</style>
